import React from 'react';

import { RechargesHistoryTable } from '@/components/Elements/RechargesHistoryTable';
import { Recharges } from '@/types';

export type MyInvoicesPageContainerProps = {
  invoices: Recharges[];
  loading: boolean;
};

export const MyInvoicesPageContainer = ({ invoices, loading }: MyInvoicesPageContainerProps) => {
  return (
    <section>
      <RechargesHistoryTable recharges={invoices} loading={loading} />
    </section>
  );
};
